<script lang="ts">
import { defineComponent, onUnmounted, onMounted } from 'vue';
import { useStatement } from './lib';

import UiSkeletonPaymentAction from '@/shared/ui/skeleton/payment-action';
import { LISTENER_ACTION_NATIVE, nativeApp } from '@/shared/services/native-app';

import FeatureDocumentsAccountStatementList from '@/features/documents/account-statement/list';
import FeatureDocumentsAccountStatementOrder from '@/features/documents/account-statement/order';

export default defineComponent({
  name: 'WidgetDocumentsAccountStatement',
  components: {
    FeatureDocumentsAccountStatementOrder,
    FeatureDocumentsAccountStatementList,
    UiSkeletonPaymentAction,
  },

  setup() {
    const {
      t,
      statement,
      loading,
      error,
      getDownloadFile,
      getAllStatement,
      getNextStatements,
      orderRef,
      createAccountStatement,
      unsubscribeSubscription,
    } = useStatement();

    onMounted(() => {
      nativeApp.loading(false);
      getAllStatement();
    });

    window.addEventListener(LISTENER_ACTION_NATIVE.REFRESH_DATA, getAllStatement, false);

    onUnmounted(() => {
      window.removeEventListener(LISTENER_ACTION_NATIVE.REFRESH_DATA, getAllStatement, false);
      unsubscribeSubscription();
    });

    return {
      t,
      error,
      loading,
      orderRef,
      statement,
      getDownloadFile,
      getAllStatement,
      getNextStatements,
      createAccountStatement,
    };
  },
});
</script>

<template>
  <feature-documents-account-statement-list
    :model-value="statement.statements"
    :loading="loading"
    :error="error"
    @refresh-statement="getAllStatement"
    @download="getDownloadFile"
    @next-statements="getNextStatements"
  />
  <div class="document-action">
    <Suspense>
      <template #default>
        <feature-documents-account-statement-order ref="orderRef" @create-account-statement="createAccountStatement" />
      </template>
      <template #fallback>
        <ui-skeleton-payment-action notification statement-order />
      </template>
    </Suspense>
  </div>
</template>

<style scoped lang="scss">
.document-action {
  position: fixed;
  left: 15px;
  right: 15px;
  bottom: 27px;
}
</style>
